import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateDeleteEmployer = {
  deleteEmployer: { data: null, loading: false, error: null },
};

export const deleteEmployer = createAsyncThunk('user/deleteEmployer', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .delete(`${process.env.REACT_APP_SERVER_API}/employers/${data.id}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerDeleteEmployer = {
  [deleteEmployer.pending]: (state) => {
    state.deleteEmployer.loading = true;
    state.deleteEmployer.error = null;
  },
  [deleteEmployer.fulfilled]: (state, action) => {
    state.deleteEmployer.loading = false;
    state.deleteEmployer.data = true;
    state.deleteEmployer.error = null;
  },
  [deleteEmployer.rejected]: (state, action) => {
    state.deleteEmployer.loading = false;
    state.deleteEmployer.error = action.payload;
  },
};
